import { defineMessages, useIntl, FormattedMessage } from "react-intl";
import { Routes, Route, useMatch } from "react-router-dom";

import { SidebarTabLink } from "common/sidebar";
import { SettingsHeader, SettingsPageWrapper } from "common/settingsv2/common";
import { ButtonStyledLink } from "common/core/button/button_styled_link";
import { Badge } from "common/core/badge";
import { useA11y } from "common/accessibility";
import { useDocumentTitles } from "util/document_title";
import { useFeatureFlag } from "common/feature_gating";

import { OAuthSettingsContent } from "./oauth_settings";
import { OAuthApplicationView } from "./oauth_settings/view";
import { GatedApiSettings } from "../api_keys/gated_api_settings";
import Styles from "../api_keys/index.module.scss";

const MESSAGES = defineMessages({
  backToApplications: {
    id: "5626496d-7549-4ed2-90db-64354c7f13ee",
    defaultMessage: "Back to applications",
  },
});

const TITLE = <FormattedMessage id="085f1c00-0c4d-48bb-a769-98ff9da081bd" defaultMessage="OAuth" />;
export const OAUTH_SETTINGS_ROOT_PREFIX = "oauth/*";
const OAUTH_SETTINGS_BASE_PATH = "oauth";

export const SettingsSidebarOAuthLink = ({ showUpgradeBadge }: { showUpgradeBadge?: boolean }) => (
  <SidebarTabLink to={OAUTH_SETTINGS_BASE_PATH}>
    <div className={Styles.wrapper}>
      {TITLE}
      {showUpgradeBadge && (
        <Badge kind="new">
          <FormattedMessage id="047162c0-a08f-40c3-9b89-f9eccc018c59" defaultMessage="Upgrade" />
        </Badge>
      )}
    </div>
  </SidebarTabLink>
);

export function OAuthSettings({ showApi }: { showApi?: boolean }) {
  const intl = useIntl();
  useA11y().useDocumentEntitler({
    title: intl.formatMessage(useDocumentTitles().settingsOAuth),
  });
  const hideApiLd = useFeatureFlag("hide-api");
  const gateApi = !showApi && hideApiLd;
  const viewingSingleApp = Boolean(
    useMatch({ path: `/settings/${OAUTH_SETTINGS_BASE_PATH}/:applicationId`, end: false }),
  );

  const backButton = viewingSingleApp ? (
    <ButtonStyledLink
      to={`/settings/${OAUTH_SETTINGS_BASE_PATH}/`}
      buttonColor="action"
      variant="tertiary"
      withIcon={{ name: "arrow-left", placement: "left" }}
    >
      {intl.formatMessage(MESSAGES.backToApplications)}
    </ButtonStyledLink>
  ) : null;

  return (
    <SettingsPageWrapper>
      <SettingsHeader title={TITLE} tabs={[]} backButton={backButton} />

      {gateApi ? (
        <GatedApiSettings type="oauth" />
      ) : (
        <Routes>
          <Route index element={<OAuthSettingsContent />} />
          <Route path=":applicationId" element={<OAuthApplicationView />} />
        </Routes>
      )}
    </SettingsPageWrapper>
  );
}
